<script>
	import Icon from '$lib/Components/Layout/Icon/Icon.svelte';

	let buildingTypes = [
		{
			src: 'buildingHotel',
			title: 'Hotels ',
			body: 'Quiet rooms, higher RevPAR, faster PIP compliance',
			href: '/solutions/commercial/soundproofing-for-hotel-guests',
		},
		{
			src: 'buildingOffice',
			title: 'Offices',
			body: ' Comfort-driven retrofits that deliver energy savings & boost productivity',
			href: '/solutions/commercial/window-insulation-for-office-buildings',
		},
		{
			src: 'buildingHistoric',
			title: 'Historic Buildings ',
			body: 'Preserve original windows while meeting energy and comfort goals',
			href: '/solutions/commercial/window-insulation-for-historic-properties',
		},
		{
			src: 'buildingHospital',
			title: 'Healthcare',
			body: 'Reduce HVAC strain and patient disturbances',
			href: '/solutions/commercial/window-insulation-for-healthcare-facilities',
		},
		{
			src: 'buildingSchool',
			title: 'Schools & Universities',
			body: 'Energy savings, acoustic control, easy install during breaks',
			href: '/solutions/commercial/window-insulation-for-schools-and-universities',
		},
		{
			src: 'buildingMultifamily',
			title: 'Multifamily',
			body: 'Comfort, quiet, and energy efficiency. Tenants remain in place.',
			href: '/solutions/commercial/window-insulation-for-multifamily-properties',
		},
	];
</script>

<ul
	class="
   grid list-none grid-cols-2 gap-3 text-center
   sm:grid-cols-3
 "
>
	{#each buildingTypes as { src, title, body }, i (i)}
		<li class="flex flex-col">
			<div>
				<Icon name={src} class="w-30" />
			</div>
			<p class="flex flex-col items-center">
				<span class="font-bold text-indow-grey-blue underline">{title}</span>
				<span class="text-center text-indow-grey-dark">
					{body}
				</span>
			</p>
		</li>
	{/each}
</ul>
